import React from 'react';
import LanguageTag from 'components/LanguageTag';
import { Tag } from 'antd';

const SurveyTitle = ({ survey }) => (survey ? (
  <>
    <LanguageTag {...survey} />
    {survey.version && <Tag>{`v${survey.version}`}</Tag>}
    {survey.title}
  </>
) : null);

export default SurveyTitle;
